import React from 'react';
import FolderAndFileTableHeading from './FolderAndFileTableHeading';
import { createTimezonedDate } from '../util/date';
import { Table } from 'react-bootstrap';
import FolderFileIcon from './FolderFileIcon';
import { useTranslation } from 'react-i18next';
const SearchResults = _ref => {
  let {
    folderSearchResults,
    fileSearchResults,
    queryIsEmpty,
    loading,
    goToFolderQuery,
    modelName
  } = _ref;
  const {
    t
  } = useTranslation();
  const resultHeading = text => {
    return /*#__PURE__*/React.createElement("h3", {
      className: "text-center mt-3"
    }, t(text));
  };
  const pathSpan = (pathName, showProjectText) => {
    return /*#__PURE__*/React.createElement("span", {
      key: 'path' + pathName
    }, showProjectText && t('project') + ': ', " ", pathName, " /");
  };
  const goToParentFolderOfFile = searchResult => {
    var _searchResult$folder;
    const pathOfFile = searchResult === null || searchResult === void 0 || (_searchResult$folder = searchResult.folder) === null || _searchResult$folder === void 0 ? void 0 : _searchResult$folder.folder_path;
    if (pathOfFile) {
      goToFolderQuery(pathOfFile[pathOfFile.length - 1].id);
    } else {
      goToFolderQuery();
    }
  };
  const goToParentFolderOfFolder = searchResult => {
    const indexOfParentFolder = searchResult.folder_path.length - 2;
    const parentFolder = searchResult.folder_path[indexOfParentFolder];
    if (parentFolder.hasOwnProperty('folderable_type')) {
      goToFolderQuery();
    } else if (parentFolder.virtual_folder) {
      goToFolderQuery(parentFolder.id, true, parentFolder);
    } else {
      goToFolderQuery(parentFolder.id);
    }
  };
  const goToParentFolder = (searchResult, isFile) => {
    if (isFile) {
      goToParentFolderOfFile(searchResult);
    } else {
      goToParentFolderOfFolder(searchResult);
    }
  };
  const renderPath = (searchResult, isFile) => {
    var _searchResult$folder2;
    const folderPath = !isFile ? searchResult.folder_path : searchResult === null || searchResult === void 0 || (_searchResult$folder2 = searchResult.folder) === null || _searchResult$folder2 === void 0 ? void 0 : _searchResult$folder2.folder_path;
    if (folderPath) {
      return folderPath.map((path, i) => {
        const showProjectText = (path === null || path === void 0 ? void 0 : path.folderable_type) === 'ClaimProjectReport';
        const isLastElement = folderPath.length - 1 === i;
        if (isLastElement && !isFile) return;
        return pathSpan(path.name, showProjectText);
      });
    } else if (!folderPath && isFile) {
      return pathSpan(modelName, true);
    }
  };
  const resultRows = searchResults => {
    return searchResults.map(searchResult => {
      var _searchResult$downloa;
      const isFile = searchResult.hasOwnProperty('notes');
      return /*#__PURE__*/React.createElement("tr", {
        key: 'folder_file_search' + searchResult.id + searchResult.name,
        onClick: () => !isFile && goToParentFolder(searchResult, isFile),
        className: !isFile ? 'cursor-pointer' : ''
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FolderFileIcon, {
        isFile: isFile,
        contentType: searchResult === null || searchResult === void 0 || (_searchResult$downloa = searchResult.download_link) === null || _searchResult$downloa === void 0 ? void 0 : _searchResult$downloa.content_type
      })), /*#__PURE__*/React.createElement("td", null, createTimezonedDate(searchResult.created_at).toCustomLocaleDateString()), /*#__PURE__*/React.createElement("td", null, isFile ? /*#__PURE__*/React.createElement("a", {
        href: searchResult.download_link.url,
        target: "_blank",
        rel: "noreferrer"
      }, searchResult.name) : searchResult.name, /*#__PURE__*/React.createElement("p", {
        className: "cursor-pointer folder-path",
        onClick: () => isFile && goToParentFolder(searchResult, isFile)
      }, renderPath(searchResult, isFile))), /*#__PURE__*/React.createElement("td", null, isFile && searchResult.notes), /*#__PURE__*/React.createElement("td", null, isFile && searchResult.uploaded_by));
    });
  };
  if (loading) return resultHeading('loading...');
  if (!folderSearchResults.length && !fileSearchResults.length || queryIsEmpty) return resultHeading('no_results_to_show');
  return /*#__PURE__*/React.createElement(React.Fragment, null, resultHeading('search_results'), /*#__PURE__*/React.createElement(Table, {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement(FolderAndFileTableHeading, null), /*#__PURE__*/React.createElement("tbody", null, resultRows(folderSearchResults), resultRows(fileSearchResults))));
};
export default SearchResults;